import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { companiesApi } from '../../api'

export default function PortalCompanies() {
  const qc = useQueryClient()
  const navigate = useNavigate()
  const [showForm, setShowForm] = useState(false)
  const [form, setForm] = useState({ name: '', code: '' })

  const { data: companies = [] } = useQuery({
    queryKey: ['companies'],
    queryFn: () => companiesApi.getAll().then(r => r.data),
  })

  const createMutation = useMutation({
    mutationFn: () => companiesApi.create(form.name, form.code),
    onSuccess: () => { qc.invalidateQueries({ queryKey: ['companies'] }); setShowForm(false); setForm({ name: '', code: '' }) },
  })

  return (
    <div>
      <div className="flex items-end justify-between mb-6">
        <div>
          <h2 className="text-xl font-semibold tracking-tight text-gray-900">회사</h2>
        </div>
        <button onClick={() => setShowForm(true)}
          className="bg-ink text-on-ink px-4 py-2 rounded-lg text-sm hover:bg-ink-hover transition">
          + 회사 추가
        </button>
      </div>

      {showForm && (
        <div className="bg-surface rounded-xl border border-gray-200/80 shadow-sm p-5 mb-6">
          <h3 className="font-semibold text-gray-700 mb-4">새 회사 등록</h3>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block text-xs text-gray-500 mb-1">회사명</label>
              <input value={form.name} onChange={e => setForm({ ...form, name: e.target.value })}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-teal-600/25 focus:border-teal-600" />
            </div>
            <div>
              <label className="block text-xs text-gray-500 mb-1">회사 코드 (고유)</label>
              <input value={form.code} onChange={e => setForm({ ...form, code: e.target.value })}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm font-mono focus:outline-none focus:ring-2 focus:ring-teal-600/25 focus:border-teal-600" placeholder="예: COMPANY_A" />
            </div>
          </div>
          <div className="flex gap-2 mt-4">
            <button onClick={() => createMutation.mutate()}
              disabled={!form.name || !form.code}
              className="bg-ink text-on-ink px-4 py-2 rounded-lg text-sm hover:bg-ink-hover transition disabled:opacity-50">등록</button>
            <button onClick={() => setShowForm(false)}
              className="border border-gray-300 text-gray-600 px-4 py-2 rounded-lg text-sm hover:bg-gray-50 transition">취소</button>
          </div>
        </div>
      )}

      <div className="bg-surface rounded-xl border border-gray-200/80 shadow-sm overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-gray-500 text-xs">
            <tr>
              <th className="text-left px-4 py-3">회사명</th>
              <th className="text-left px-4 py-3">코드</th>
              <th className="text-left px-4 py-3">상태</th>
              <th className="text-left px-4 py-3">생성일</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {companies.length === 0 && (
              <tr><td colSpan={4} className="px-4 py-8 text-center text-gray-400 text-xs">등록된 회사가 없습니다.</td></tr>
            )}
            {companies.map(c => (
              <tr key={c.id} onClick={() => navigate(`/admin/companies/${c.id}`)}
                className="hover:bg-gray-50 cursor-pointer">
                <td className="px-4 py-3 font-medium text-gray-800">{c.name}</td>
                <td className="px-4 py-3 font-mono text-xs text-gray-500">{c.code}</td>
                <td className="px-4 py-3">
                  <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${c.isActive ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-500'}`}>
                    {c.isActive ? '활성' : '비활성'}
                  </span>
                </td>
                <td className="px-4 py-3 text-gray-400 text-xs">{new Date(c.createdAt).toLocaleDateString('ko-KR')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
